<div class='container'>
  <p>
    Copyright © 2018-2021 Frog Connexion all rights reserved - Website {{version}} | API {{build?.version}}
    <br/>Ce site a été développé sans colorants ni conservateurs par Frog Connexion, pour vous apporter de la joie et du bonheur. Sisi c'est vrai.
  </p>
</div>
